export default __webpack_public_path__ + "static/media/booked.c079462d.svg";